var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3751 3.29395C14.7657 3.68457 14.7657 4.31895 14.3751 4.70957L6.3751 12.7096C5.98447 13.1002 5.3501 13.1002 4.95947 12.7096L0.959473 8.70957C0.568848 8.31895 0.568848 7.68457 0.959473 7.29395C1.3501 6.90332 1.98447 6.90332 2.3751 7.29395L5.66885 10.5846L12.9626 3.29395C13.3532 2.90332 13.9876 2.90332 14.3782 3.29395H14.3751Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ffd9bd4626284ac9edeb2f98b6e5be81.svg";
export { ForwardRef as ReactComponent };